import { render } from "./ManagementDate.vue?vue&type=template&id=54b46d27"
import script from "./ManagementDate.vue?vue&type=script&lang=js"
export * from "./ManagementDate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__